import React from "react";

const Header = () => {
  return (
    <div className="" id="header">
      <span className="logo">
        <img alt="logo" src={require("../Assets/Images/usdlogo3.png")} />
      </span>
    </div>
  );
};

export default Header;
